import React from "react";
import { useTranslation } from "react-i18next";

import { Errors } from "fe-shared/src/types/common";
import { TextInput, Tooltip } from "fe-shared/src/components";

import { transformIntegerValue } from "../modules/helpers";
import styles from "../RetreadingTransactionFormDialog.module.scss";

interface Props {
  errors: Errors;
  values: Record<string, number | undefined>;
  updateValue: (key: string, value: unknown, isValidated?: boolean) => void;
  validateValue: (key: string) => void;
  recoveryGain: number;
}

const RecoveryMaterialsTable = ({
  values,
  errors,
  recoveryGain,
  updateValue,
  validateValue,
}: Props) => {
  const { t } = useTranslation();

  return (
    <table>
      <thead>
        <tr className={styles.dialogTableHeader}>
          <th className={styles.dialogTableHeaderLabel}>
            {t(
              "transactions.grid.createRetreadingTransaction.form.recoveryInfo"
            )}
          </th>
          <th>
            {t("transactions.grid.createRetreadingTransaction.form.weight")}
          </th>
        </tr>
      </thead>
      <tbody className={styles.dialogTableBody}>
        {Object.entries(values).map(([materialKey, materialValue]) => {
          const valueKey: string = `recoveryInfoMaterials.${materialKey}`;

          return (
            <tr key={materialKey}>
              <td>
                <span className={styles.required}>
                  {t(
                    `transactions.grid.createRetreadingTransaction.form.recoveryMaterials.${materialKey}`
                  )}
                </span>
              </td>
              <td className={styles.dialogTableData}>
                <TextInput
                  id={`${materialKey}-input`}
                  min="0"
                  max="9999999999"
                  type="number"
                  placeholder="0"
                  value={materialValue}
                  onChange={(e, v) => {
                    updateValue(
                      valueKey,
                      v !== "" ? Number(v) : undefined,
                      true
                    );
                  }}
                  onBlur={() => validateValue(valueKey)}
                  isError={!!errors[valueKey]}
                  inputClassName={styles.formTableInput}
                  wrapperClassName={styles.formTableWrapper}
                  width="80px"
                  required
                  transformValue={transformIntegerValue}
                />
              </td>
            </tr>
          );
        })}
        <tr>
          <td>
            <div className={styles.dialogTableRecoveryGainLabel}>
              {t(
                "transactions.grid.createRetreadingTransaction.form.recoveryGain"
              )}
              <Tooltip
                wrapperClassName={styles.dialogTableRecoveryGainTooltipWrapper}
              >
                {t("transactions.details.recoveryGainTooltip")}
              </Tooltip>
            </div>
          </td>
          <td width="82" className={styles.dialogTableRecoveryGain}>
            {recoveryGain}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default RecoveryMaterialsTable;
